import React, { Component } from 'react';
import { connect } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';
import LOOKUP from 'constants/lookup';
import { ProductOrderStatus, ApprovalStatus } from 'constants/enums';
import { clearPOSError, getOrderDetail, posEmailReceipt } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import GenericTable from 'screens/components/advanced/GenericTable';
import Button from 'screens/components/basic/Button';
import POSEmailReceiptDialog from '../../sales/pos/POSEmailReceiptDialog';
import OrderPrintInvoice from './OrderPrintInvoice';
class OrderDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openEmailDialog: false
        }

        this.getProducts = this.getProducts.bind(this);
    }

    componentDidMount() {
        this.props.getOrderDetail(this.props.orderId.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.emailInvoicetSuccess && this.props.emailInvoicetSuccess != prevProps.emailInvoicetSuccess) {
            this.props.showSnackbar(`Email sent to ${this.props.emailAddress} successfully`);
            this.closeEmailDialog();
            this.clearEmailForm();
        }

        if (this.props.emailInvoiceFailed && this.props.emailInvoiceFailed !== prevProps.emailInvoiceFailed) {
            const errorMessage = this.props.emailInvoiceFailed.error === 16
                ? LOOKUP.pos.messages.emailReceiptNotSent
                : LOOKUP.pos.messages.emailReceiptInvalid;
            this.props.showError(errorMessage);
        }
    }

    getProducts = () => {
        const products = (this.props.orderDetail.products || []).map(product => {
            let discountAmount = 0;
            if (product.discountAmount && product.discountType) {
                if (product.discountType == "Percentage") {
                    discountAmount = `${product.discountAmount}%`
                } else {
                    discountAmount = product.discountAmount;
                }
            }
            return {
                productName: product.name,
                productPrice: `$ ${(product.pricePerUnit ? product.pricePerUnit : Number(0)).toFixed(2)}`,
                productQuantity: product.quantity,
                productDiscount: `${(product.discountAmount ? discountAmount : Number(0))}`,
                productTotalPrice: `$${(product.newPrice ? product.newPrice : Number(0)).toFixed(2)}`,
                productStatus: ProductOrderStatus[product.status],
                productNotes: [5, 6, 7, 8, 9, 10].includes(product.status) ? product.notes : ""
            };
        });
        return products;
    }

    getApprovals = () => {
        const approvals = ((this.props.orderDetail.approvals || []).map(approval => {
            return {
                employeeName: `${approval.employeeFirstName} ${approval.employeeLastName}`,
                date: approval.createdDateString,
                approvalType: ApprovalStatus[approval.approvalType]
            };
        }));

        return approvals;
    }

    printInvoice = () => {
        if (this.props.padVersion) {
            buildURLScheme(document.getElementById('invoice-page').innerHTML);
        } else {
            return new Promise(() => {
                setTimeout(() => {
                    document.getElementById('to-print').innerHTML = document.getElementById('invoice-page').innerHTML;
                    // console.log(document.getElementById('invoice-page').innerHTML);
                    window.print();
                }, 1000)
            });
        }
    }

    openEmailDialog = () => {
        if (this.props.orderDetail.patientEmail) {
            this.props.formInput(this.props.orderDetail.patientEmail, "OrderEmailInvoiceDialogEmail");
        }

        this.setState({
            openEmailDialog: true
        });
    }

    closeEmailDialog = () => {
        this.setState({
            openEmailDialog: false
        });
        this.clearEmailForm();
    }

    clearEmailForm = () => {
        this.props.clearFormInput("OrderEmailInvoiceDialogEmail")
        this.props.clearFormInput("posEmailReceiptSuccess");
        this.props.clearPOSError();
    }

    sendEmailInvoice = () => {
        this.props.sendEmailInvoice({ orderId: this.props.orderDetail.id, email: this.props.emailAddress, isInvoice: true });
    }

    render() {
        const p = this.props;
        const order = p.orderDetail;
        const approvals = this.getApprovals();
        let columns = [...LOOKUP.menu.admin.orderDetail.tableColumns];
        if (order.status == "Returned" || order.status == "ReturnedPartial") {
            columns.push({ key: "productNotes", label: "Notes" })
        }

        return (
            <div className="order_detail_wrapper purpleText">
                <Button
                    className=" p-0 pull-right"
                    type="PrintButton"
                    onTouchTap={() => this.printInvoice()}
                />
                {order && order.status == "Opened" &&
                    <Button
                        name="sendemailbutton"
                        type="SendEmailButton"
                        className=" pull-right"
                        style={{ minWidth: 'unset' }}
                        onTouchTap={() => this.openEmailDialog()}
                    />
                }
                <br />
                <h6 className="d-flex justify-content-center"><b>{LOOKUP.menu.admin.orderDetail.labels.orderNumber} : {order.id}</b></h6>
                <div className="row d-flex mt-2 justify-content-between">
                    <div className="row col-xs-12 col-sm-5 col-md-5 col-lg-5 col-xl-5">
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right ">
                            <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.branch}</b></h6>
                            <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.patientNumber}</b></h6>
                            <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.patientFirstName}</b></h6>
                            <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.patientLastName}</b></h6>
                            <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.employee}</b></h6>
                        </div> {/* .col for labels */}
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 purpleText">
                            <h6>{order.branchName}</h6>
                            {/* Patient Number comes here */}
                            <h6>{order.patientId}</h6>
                            {/* Patient First Name comes here */}
                            <h6>{order.patientFirstName ? order.patientFirstName : "Anonymous"}</h6>
                            {/* Patient Last Name comes here */}
                            <h6>{order.patientLastName ? order.patientLastName : "Anonymous"}</h6>
                            <h6>{order ? `${order.employeeFirstName} ${order.employeeLastName}` : ""}</h6>
                        </div> {/* .col for values */}
                    </div>{/* .col */}
                    
                    <div className="row col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-right purpleText">
                            <h6><b>{LOOKUP.menu.admin.orderDetail.labels.terminal}</b></h6>
                            <h6><b>{LOOKUP.menu.admin.orderDetail.labels.status}</b></h6>
                            <h6><b>{LOOKUP.menu.admin.orderDetail.labels.date}</b></h6>
                            {order.onlineOrderCode ? (<h6><b>{LOOKUP.menu.admin.orderDetail.labels.onlineOrderCode}</b></h6>) : ''}
                        </div> {/* .col for labels */}
                        <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                            <h6>{order.deviceName}</h6>
                            {/* Status comes here */}
                            <h6>{order.status}</h6>
                            {/* Date comes here */}
                            <h6>{order.createdDateString}</h6>
                            {order.onlineOrderCode ? (<h6>{order.onlineOrderCode}</h6>) : ''}
                        </div> {/* .col for values */}
                    </div> {/* .col */}
                </div> {/* .row */}

                <div className="row mt-2">
                    <div className="w-80 center-auto purpleText">
                        <h6><b>ITEMS</b></h6>
                        <GenericTable
                            multiSelectable={false}
                            enableSelectAll={false}
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            displayRowCheckbox={false}
                            selectable={false}
                            columns={columns}
                            rows={this.getProducts()}
                            stripedRows={true}
                        />
                    </div> {/* .w-80 center-auto */}
                </div> {/* .mt-2 */}

                <div className="row mt-3">
                    <div className="col-lg-4 col-md-4 col-sm-5 col-xs-4 text-center">
                        {/* {order && order.qrCode && order.qrCode.length>0 && 
                        <React.Fragment>
                            {!order.qrCode.includes(`TSS-JWToken`) ? ( order.qrCode[order.qrCode.length-1] == 'TSS is not available' ?
                            <div> {order.qrCode[order.qrCode.length-1]} </div> : 
                            <QRCodeSVG value={order.qrCode[order.qrCode.length-1]} size={128} />) : order.qrCode} 
                            
                        </React.Fragment>} */}
                    </div>
                    <div className="col-lg-6 col-md-5 col-sm-5 col-xs-6 text-right">
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.subTotal}</b></h6>
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.discountOnProduct}</b></h6>
                        {order.isPriceMatchPlus && (
                            <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.priceMatch}</b></h6>
                        )}
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.subTotalIncludingDiscount}</b></h6>
                        {
                            order && order.taxesRate && order.taxesRate.length > 0 && order.taxesRate.map(t => (<h6 className="nowrap"><b>{t.name}</b></h6>))
                        }
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.deposit}</b></h6>
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.shippingFee}</b></h6>
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.total}</b></h6>
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.paid}</b></h6>
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.due}</b></h6>
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.change}</b></h6>
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.tips}</b></h6>
                        {order.storeCredit?.value &&
                        <>
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.storeCreditCode}</b></h6>
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.storeCreditCurrentValue}</b></h6> 
                        <h6 className="nowrap"><b>{LOOKUP.menu.admin.orderDetail.labels.storeCreditValue}</b></h6>
                        </>
                        }
                        <hr />
                        {
                            order && order.payments && order.payments.length > 0 && (<div>
                                <h6 className="nowrap mt-3"><b>{LOOKUP.menu.admin.orderDetail.labels.payments}</b></h6>
                                {
                                    order.payments.map((item, index) => {
                                        return (
                                            <h6 className="nowrap" key={index}><b>{item.name}</b></h6>
                                        );
                                    })
                                }
                            </div>)
                        }
                    </div> {/* .col for labels */}

                    <div className="col-lg-1 col-md-3 col-sm-2 col-xs-2">
                        {/* Subtotal comes here */}
                        <h6>$ {(order.subTotal ? order.subTotal : Number(0)).toFixed(2)}</h6>

                        {/* Discount on product comes here */}
                        <h6>$ {((order.subTotal - order.subTotalIncludingDiscounts) ? (order.subTotal - order.subTotalIncludingDiscounts) : Number(0)).toFixed(2)}</h6>

                        {/* Price Match comes here */}
                        {order.isPriceMatchPlus && (
                            <h6> {order.isPriceMatchPlus == true ? 'True' : 'False'}</h6>)}

                        {/* Subtotal including discount comes here */}
                        <h6>$ {(order.subTotalIncludingDiscounts ? order.subTotalIncludingDiscounts : Number(0)).toFixed(2)}</h6>

                        {/* Taxes Rate */}
                        {
                            order && order.taxesRate && order.taxesRate.length > 0 && order.taxesRate.map(t => (<h6 className="nowrap">$ {(t.value ? t.value : Number(0)).toFixed(2)}</h6>))
                        }

                        {/* Deposits */}
                        {
                            <h6>$ {(order.depositAmount > 0 ? order.depositAmount : Number(0)).toFixed(2)}</h6>
                        }

                        {/* Shipping Cost */}
                        {
                            <h6>$ {(order.shippingCost > 0 ? order.shippingCost : Number(0)).toFixed(2)}</h6>
                        }

                        {/* Total comes here */}
                        <h6><b>$ {(order.total ? order.total : Number(0)).toFixed(2)}</b></h6>

                        {/* Paid comes here */}
                        <h6>$ {((order.total - order.balanceDue) ? (order.total - order.balanceDue) : Number(0)).toFixed(2)}</h6>

                        {/* Due comes here */}
                        <h6>$ {(order.balanceDue ? order.balanceDue : Number(0)).toFixed(2)}</h6>

                        {/* Change comes here */}
                        <h6>$ {(order.change ? order.change : Number(0)).toFixed(2)}</h6>

                        <h6>$ {(order.tipAmount ? order.tipAmount : Number(0)).toFixed(2)}</h6>
                        {order.storeCredit?.code && (
                        <h6>{order.storeCredit.code}</h6>
                     )}
                       {order.storeCredit?.currentValue && (
                        <h6>$ {(order.storeCredit?.currentValue ? order.storeCredit?.currentValue : Number(0)).toFixed(2)}</h6>
                     )}
                      {order.storeCredit?.value && (
                        <h6>$ {(order.storeCredit?.value ? order.storeCredit?.value : Number(0)).toFixed(2)}</h6>
                    )}
 
                        <hr />
                        {/* Payments */}
                        {
                            order && order.payments ? order.payments.map((item, index) => {
                                return (
                                    <h6 className="nowrap" key={index}>$ {item.value.toFixed(2)}</h6>
                                );
                            }) : null
                        }
                    </div> {/* .col for values */}
                </div> {/* .row */}

                {((order.approvals || []).length > 0) ?
                    <div className="mt-2">
                        <div className="w-80 center-auto">
                            <h6 className="purpleText"><b>Approvals for order</b></h6>
                            <div className="alert alert-warning">
                                {order.comment || `No comment was left`}
                            </div>
                            <GenericTable
                                className="table_center order_detail_table tableHeaderwhiteColorFont"
                                multiSelectable={false}
                                enableSelectAll={false}
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                displayRowCheckbox={false}
                                selectable={true}
                                columns={LOOKUP.menu.admin.orderApprovalsColumns}
                                rows={approvals}
                                stripedRows={true}
                            />
                        </div>
                    </div>
                    : undefined}

                <OrderPrintInvoice name="invoice-page" order={this.props.orderDetail} getProducts={this.getProducts} />
                <POSEmailReceiptDialog name="OrderEmailInvoiceDialog" show={this.state.openEmailDialog} onCancel={() => this.closeEmailDialog()} onComfirm={() => this.sendEmailInvoice()} />
            </div>
        );
    }
}

function mapStatetoProps(state) {
    return {
        orderDetail: state.entity.orderDetail,
        emailAddress: state.form["OrderEmailInvoiceDialogEmail"] || null,
        emailInvoicetSuccess: state.form["posEmailReceiptSuccess"],
        emailInvoiceFailed: state.entity.posOrderError
    };
}

function mapDispatchToProps(dispatch) {
    return {
        sendEmailInvoice: (orderId) => dispatch(posEmailReceipt(orderId)),
        getOrderDetail: (orderId) => dispatch(getOrderDetail(orderId)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        clearPOSError: () => dispatch(clearPOSError())
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(OrderDetail);
